var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "#F09A0FFF",
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 32 32",
        "xml:space": "preserve",
        width: "20px",
        height: "20px",
      },
    },
    [
      _c("g", { attrs: { id: "SVGRepo_bgCarrier", "stroke-width": "0" } }),
      _vm._v(" "),
      _c("g", {
        attrs: {
          id: "SVGRepo_tracerCarrier",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { id: "SVGRepo_iconCarrier" } }, [
        _c("path", {
          attrs: {
            id: "language--02_1_",
            d: "M7.169,18h0.794l-3.104-6.652H4.207L1.103,18h0.794l0.765-1.64h3.741L7.169,18z M2.998,15.64 l1.535-3.289l1.535,3.289C6.068,15.64,2.998,15.64,2.998,15.64z M22.033,7.36c-2.167,0-3.36-1.016-3.36-2.86V3h0.721v1.5 c0,1.44,0.863,2.14,2.64,2.14c1.19,0,2.275-0.152,2.544-1.78H23.5c-0.646,0-2.36,0-2.36-1.86c0-1.16,0.742-2.36,1.982-2.36 c1.526,0,2.238,1.067,2.238,3.36c0,0.047-0.001,0.094-0.002,0.14h1.175v0.72h-1.229C25.003,7.041,23.503,7.36,22.033,7.36z M23.122,1.36c-0.79,0-1.262,0.834-1.262,1.64c0,0.853,0.413,1.14,1.64,1.14h1.139C24.64,4.094,24.64,4.047,24.64,4 C24.64,1.36,23.615,1.36,23.122,1.36z M26.36,31h-0.72c0-4.349-2.937-8.173-7.142-9.3c-0.144-0.038-0.248-0.159-0.265-0.307 c-0.018-0.146,0.058-0.289,0.188-0.358c1.678-0.898,2.72-2.636,2.72-4.534c0-2.835-2.306-5.141-5.141-5.141 c-2.834,0-5.141,2.306-5.141,5.141c0,1.898,1.042,3.637,2.72,4.534c0.131,0.07,0.206,0.214,0.188,0.361s-0.125,0.269-0.27,0.305 C9.295,22.762,6.36,26.586,6.36,31H5.64c0-4.468,2.801-8.373,6.904-9.767c-1.5-1.096-2.404-2.844-2.404-4.732 c0-3.232,2.629-5.861,5.86-5.861s5.861,2.629,5.861,5.861c0,1.893-0.908,3.646-2.415,4.739C23.555,22.688,26.36,26.593,26.36,31z M11.863,2.36c-0.003,0.875-0.095,2.489-1.205,3.67c0.623,0.363,1.401,0.61,2.347,0.61v0.72c-1.198,0-2.161-0.355-2.917-0.853 C9.299,7.064,8.274,7.36,7.004,7.36V6.64c1.014,0,1.849-0.197,2.493-0.584c-0.69-0.621-1.132-1.354-1.304-1.957l0.692-0.198 c0.151,0.528,0.547,1.175,1.182,1.71c0.005-0.005,0.012-0.008,0.017-0.013c0.975-0.982,1.056-2.44,1.059-3.238H7.004V1.64h2.64V0.5 h0.72v1.14h2.64v0.72C13.004,2.36,11.863,2.36,11.863,2.36z M31.533,12.36h-2.14v6h-0.721v-3.5h-1.64c-0.385,0-1.64,0.083-1.64,1.14 c0,0.788,0.642,1.405,1.277,1.667l-0.275,0.666c-0.857-0.354-1.723-1.212-1.723-2.333c0-1.13,0.927-1.86,2.36-1.86h1.64v-1.78h-4.64 v-0.72h4.64h0.721h2.14L31.533,12.36L31.533,12.36z",
          },
        }),
        _vm._v(" "),
        _c("rect", {
          staticStyle: { fill: "none" },
          attrs: { id: "_Transparent_Rectangle", width: "32", height: "32" },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }